/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletInfo } from "./WalletInfo";
import * as t from "io-ts";

/**
 * Wallets information
 */

// required attributes
const WalletsR = t.interface({});

// optional attributes
const WalletsO = t.partial({
  wallets: t.readonlyArray(WalletInfo, "array of WalletInfo")
});

export const Wallets = t.intersection([WalletsR, WalletsO], "Wallets");

export type Wallets = t.TypeOf<typeof Wallets>;
